module.exports = __webpack_public_path__ + "images/hero-banner-background-content.png";